import {
  DeviceModeEnum,
  useDeviceModeContext,
} from 'client/context/DeviceModeContext'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { components, SingleValueProps } from 'react-select'
import { Monitor01Icon } from 'src/editor/shared/icons/monitor-01-icon'
import { Phone01Icon } from 'src/editor/shared/icons/phone-01-icon'
import {
  OptionType,
  OptionValue,
  SelectNew,
} from 'src/editor/shared/ui-lib/select-new/select-new'
import { twMerge } from 'tailwind-merge'

interface DeviceModeSelectProps {
  className?: string
}

export const DeviceModeSelect = ({ className }: DeviceModeSelectProps) => {
  const { setDeviceMode, deviceMode } = useDeviceModeContext()
  const { t } = useTranslation()
  const options: OptionType<DeviceModeEnum>[] = [
    {
      value: DeviceModeEnum.Desktop,
      label: t('settings_options.device_appearance.desktop'),
    },
    {
      value: DeviceModeEnum.Mobile,
      label: t('settings_options.device_appearance.mobile'),
    },
  ]
  const getSelectedOption = () => {
    return options.find(el => el.value === deviceMode) ?? options[0]
  }
  return (
    <SelectNew<DeviceModeEnum>
      wrapperClassName={twMerge('mb-4 w-[130px]', className)}
      options={options}
      onChange={option =>
        setDeviceMode(option?.value ?? DeviceModeEnum.Desktop)
      }
      selectedOption={getSelectedOption()}
      components={{ SingleValue }}
      isSearchable={false}
    />
  )
}

const SingleValue = (
  props: SingleValueProps<OptionType<DeviceModeEnum>, false>,
) => {
  const { data } = props

  return (
    <components.SingleValue
      {...props}
      className={twMerge(props.className, 'flex items-center gap-1.5')}
    >
      {data.label === DeviceModeEnum.Desktop ? (
        <Monitor01Icon
          width={16}
          height={16}
          className="[&>path]:fill-iconSecondary"
        />
      ) : (
        <Phone01Icon
          width={16}
          height={16}
          className="[&>path]:fill-iconSecondary"
        />
      )}
      <span>{data.label}</span>
    </components.SingleValue>
  )
}
